import './css/tabs.css';
import hotelcss from './css/hotelhotellist.module.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import React from "react";
import { useState } from 'react'
import { json, useNavigate } from 'react-router-dom'
import {
    sendhoteldata, getallstatushotels, gethotel,
    updateHotelData, getRooms, getRoomsTypes,
    getserverurl, createroom, createroomtype, createfloor, editFloor, deleteFloor,
    editkamer, deleteRoom, deleteRoomtype, editkamerType, saveCleaningtask, getCleaningtasks, editCleaningTask, deleteCleaningTask,
    saveCleaningtype, getCleaningtypes, editCleaningType, deleteCleaningType, savelinkedTasks, getlinkedtasks, deleteGeneralServicestasks, editGeneralServicestask
} from "../dbconnector/connector";
import { useParams } from "react-router-dom";
import { pdfjs } from 'react-pdf';
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import { confirmAlert } from 'react-confirm-alert';

import Button from 'react-bootstrap/Button';
import { MdEdit, MdDelete } from "react-icons/md";
import { MdCleaningServices } from "react-icons/md";
import HotelNode from '../customNodes/HotelNode';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();


const Createhotel = (props) => {
    const t = props.translation
    const [contract, setContract] = useState({ value: '' })
    const [hotel, setHotel] = useState('');
    const navigate = useNavigate();
    const [trackMouse, setTrackMouse] = useState(false)
    const [coord, setCoord] = useState({ x: 0, y: 0 });


    const handleMouseMove = (e) => {
        if (trackMouse === true) {
            setCoord({ x: e.clientX, y: e.clientY });
        }
    };

    const setMouseDown = (e) => {
        setTrackMouse(true)
    };

    const stopMouseMove = (e) => {
        setTrackMouse(false)
    };

    //onMouseDown={setMouseDown} onMouseUp={stopMouseMove}

    const onSubmit = (e) => {
        e.preventDefault();
        const response = sendhoteldata({ ...hotel, Contract: contract })
        response.then(res => {
            if (res.status === 200) {
                navigate('/hotels')
            } else {
                setErrorMessage(res.status + ": " + res.statusText)
            }
        });
    }

    const handleitemchange = (e) => {
        setHotel((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })

    }

    const handleCancel = () => {
        navigate('/hotels');
    }
    const changecheckbox = (e) => {
        setHotel((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })
    }

    useEffect(() => {
        setHotel({ ...hotel, active: 1 })
    }, [])

    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }

    const changedate = (e, datefield) => {
        setHotel((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
    }
    return (
        <>
            <div id="main" onMouseMove={handleMouseMove} onMouseDown={setMouseDown} onMouseUp={stopMouseMove} >
                <div className='mousecoordinates'>
                    Mouse coordinates: {coord.x} {coord.y}
                </div>
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="return" className="form">
                    <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={() => navigate("/hotels")} >{t('Naaroverzicht')}</Button>
                </div>
                <HotelNode
                    rights={props.rights}
                    t={props.translation}
                    isDisabled={false}

                    data={{ hotel: hotel }}
                    floorsarray={[]}
                    cleaningtaskstoassignarray={[]}
                    kamersarray={[]}
                    kamertypesarray={[]}
                    cleaningtypearray={[]}
                    cleaningtaskarray={[]}
                    events={{
                        changedate: changedate,
                        handleCancel: handleCancel,
                        changecheckbox: changecheckbox,
                        handleitemchange: handleitemchange,
                        setContract: setContract,
                        kamerstab: null,
                        onSubmit: onSubmit,
                        handleMouseMove: handleMouseMove,
                        setMouseDown: setMouseDown,
                        stopMouseMove: stopMouseMove
                    }}
                    tabsDisabled={true}
                    MousePosition={coord}
                />
            </div>
        </>

    )
}

const Viewhotels = (props) => {
    const t = props.translation
    const [hotels, sethotels] = useState([]);
    const navigate = useNavigate();
    const [trackMouse, setTrackMouse] = useState(false)
    const [coord, setCoord] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        if (trackMouse === true) {
            setCoord({ x: e.clientX, y: e.clientY });
        }
    };
    const setMouseDown = (e) => {
        setTrackMouse(true)
    };
    const stopMouseMove = (e) => {
        setTrackMouse(false)
    };

    useEffect(() => {
        try {
            const hotels = getallstatushotels();
            hotels.then((hotellist) => {
                if (hotellist.status === 200) {
                    sethotels(hotellist.items)
                    const ZoekOpNaam = document.getElementById("ZoekOpNaam");
                    const ZoekOpAfNr = document.getElementById("ZoekOpAfNr");
                    ZoekOpNaam.value = sessionStorage.getItem('zoekhotelopnaam')
                    ZoekOpAfNr.value = sessionStorage.getItem('zoekhotelopafdln')
                    const active = document.getElementById("activehotel");
                    active.addEventListener("click", function (e) {
                        filter(hotellist)
                    })

                    ZoekOpNaam.addEventListener("input", function (e) {
                        if (sessionStorage.getItem('selectedhotel') !== null) {
                            sessionStorage.removeItem('selectedhotel')
                        }
                        sessionStorage.setItem('zoekhotelopnaam', e.target.value)
                        filter(hotellist)
                    })

                    ZoekOpAfNr.addEventListener("input", function (e) {
                        if (sessionStorage.getItem('selectedhotel') !== null)
                            sessionStorage.removeItem('selectedhotel')
                        sessionStorage.setItem('zoekhotelopafdln', e.target.value)
                        filter(hotellist)
                    })
                    active.checked = "true"
                    Createhotelslist(hotellist.items, navigate);
                    if (sessionStorage.getItem('zoekhotelopnaam') !== null || sessionStorage.getItem('zoekhotelopafdln') !== null) {
                        filter(hotellist)
                    }
                } else {
                    setErrorMessage(t("error_retreivingHotels"))
                }
            })
        } catch (error) {
            setErrorMessage(t("error_retreivingHotels"))
        }
    }, []);

    function filter(hotellist) {
        const ZoekOpNaam = document.getElementById("ZoekOpNaam")
        const ZoekOpAfNr = document.getElementById("ZoekOpAfNr")
        const filteredhotels = hotellist.items.filter(element => {
            if (element.Name.toLowerCase().includes(ZoekOpNaam.value.toLowerCase()) && element.nr_afd.toString().includes(ZoekOpAfNr.value)) {
                return element
            }
        })
        Createhotelslist(filteredhotels, navigate)
    }

    const Createhotelslist = (hotellist, navigate) => {
        let listForHotels = document.getElementById("hotelsList");
        if (listForHotels === null) {
            listForHotels = document.createElement("div");
            listForHotels.id = "hotelsList";
            const upperdiv = document.getElementById("main");
            upperdiv.appendChild(listForHotels);
        } else {
            listForHotels.innerHTML = ""
        }
        const hotellistactivefilter = hotellist.filter(element => !document.getElementById("activehotel").checked ? element.active === 0 : element.active === 1)

        hotellistactivefilter.forEach((hotel, index) => {
            const hotellink = document.createElement("div");

            const selector = document.createElement("input");
            selector.className = "smallselector";
            selector.id = "selector_" + hotel.Hotel_ID

            const IdP = document.createElement("p");
            IdP.className = hotelcss.textalignright;
            IdP.innerText = hotel.nr_afd;
            hotellink.appendChild(IdP);

            const nameP = document.createElement("p");
            nameP.innerText = hotel.Name;
            hotellink.appendChild(nameP);

            const description = document.createElement("p");
            description.innerText = hotel.straatnaam + " " + hotel.huisnummer + ", " + hotel.zipcode + " " + hotel.gemeente;
            hotellink.appendChild(description);

            if (sessionStorage.getItem('selectedhotel') !== null && sessionStorage.getItem('selectedhotel') === hotel.Hotel_ID.toString()) {
                hotellink.className += hotelcss.hotelselectedRow
                hotellink.appendChild(selector);
            } else {
                selector.style.visibility = "hidden"
                if (index % 2 === 0) {
                    hotellink.className += hotelcss.linkVarient1
                } else {
                    hotellink.className += hotelcss.linkVarient2
                }
            }

            hotellink.addEventListener('click', function (e) {
                sessionStorage.setItem('selectedhotel', hotel.Hotel_ID)
                navigate("/hotels/" + hotel.Hotel_ID);
            });

            listForHotels.appendChild(hotellink)
        });
        if (sessionStorage.getItem('selectedhotel') !== null && document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')) !== null) {
            document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')).focus()
            document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')).disabled = true;
        }
    }


    return (
        <>
            <div id="main" onMouseMove={handleMouseMove} onMouseDown={setMouseDown} onMouseUp={stopMouseMove} >
                <div className='mousecoordinates'>
                    Mouse coordinates: {coord.x} {coord.y}
                </div>
                <header>
                    <div id="errordiv" className='error'>
                    </div>
                </header>
                <div id="newuser" className="form">
                    <Button id="addhotelsbutton" onClick={() => (navigate("/createhotel"))} >{t('NewHotel')}</Button>
                </div>
                <div id="filters" className="form" >
                    <label className='formtitleContentBox'>{t("filterinstellingen")}</label>
                    <br></br>
                    <div className="contentbox">
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('Active')}
                            </label>
                            <input type="checkbox" id="activehotel" className="checkbox"></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('HotelName')}:
                            </label>
                            <input type="text" id="ZoekOpNaam" placeholder="Search"></input>
                        </div>
                        <div className="formElement">
                            <label className='labelcolor'>
                                {t('NR_Dep')}:
                            </label>
                            <input type="text" id="ZoekOpAfNr" placeholder="Search"></input>
                        </div>

                    </div>
                    <div id="headertabled" className={hotelcss.tableheader}><p id="status"> {t('NR_Dep')}</p><p id="type"> {t('Name')}</p><p id="senddate"> {t('Address')}</p></div>
                    <div id="hotelsList" className="list">
                    </div>
                </div>
            </div>

        </>
    )
}

const HotelView = (props) => {
    const t = props.translation
    const navigate = useNavigate()
    const [contract, setContract] = useState({ value: '' })
    const [hotel, setHotel] = useState({});
    const [kamers, setKamers] = useState({});
    const [floors, setFloors] = useState({});
    const [kamerTypes, setKamerTypes] = useState({});
    const [addkamer, setaddkamer] = useState({});
    const [kamertypesarray, setkamertypesarray] = useState([]);
    const [kamersarray, setkamersarray] = useState([]);
    const [floorsarray, setfloorsarray] = useState([]);
    const [cleaningtaskarray, setcleaningtaskarray] = useState([]);
    const [cleaningtaskstoassignarray, setcleaningtaskstoassignarray] = useState([]);
    const [cleaningTasks, setCleaningTasks] = useState({});
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [CleaningTypes, setCleaningTypes] = useState({});
    const [generalservicestasksarray, setgeneralservicestasksarray] = useState([]);
    const [generalservicestasks, setgeneralservicestasks] = useState([]);
    const [toUpdate, setToUpdate] = useState({});
    const [iconDisabled, setIconDisabled] = useState(false);
    const [tabsDisabled, setTabsDisabled] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [linkedtasks, setLinkedtasks] = useState({});
    let { id } = useParams();
    const [trackMouse, setTrackMouse] = useState(false)
    const [coord, setCoord] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        if (trackMouse === true) {
            setCoord({ x: e.clientX, y: e.clientY });
        }
    };

    const setMouseDown = (e) => {
        setTrackMouse(true)
    };

    const stopMouseMove = (e) => {
        setTrackMouse(false)
    };


    const addKamerfield = () => {
        setIconDisabled(true);
        setTabsDisabled(true);
        let list = document.getElementById("roomslist");

        const kamerdiv = document.createElement("div");
        //addname element to div
        const kamernummer = document.createElement("input");
        kamernummer.onchange = (e) => setaddkamer({ ...addkamer, kamernummer: e.target.value })
        kamernummer.className = "inputTable";
        kamernummer.type = "text";
        kamernummer.id = "kamernummerinput";
        kamernummer.focus();
        kamerdiv.appendChild(kamernummer);

        const Type = document.createElement("select");
        Type.onchange = (e) => setaddkamer({ ...addkamer, Type: e.target.value })
        Type.id = "kamertypeid"
        kamerdiv.appendChild(Type);

        kamerdiv.className = hotelcss.RoomlinkVarientInput
        const kameraaray = document.getElementById("kamersarray")

        kameraaray.insertBefore(kamerdiv, kameraaray.firstChild);


        for (const type of kamerTypes) {
            const option = document.createElement("option")
            option.innerText = type.Naam;
            option.value = type.id;
            Type.appendChild(option)

        }

        const IconSave = document.getElementById("IconSave").cloneNode(true);

        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";
        kamerdiv.id = "inputdiv"
        kamerdiv.appendChild(addbut);
        addbut.onclick = handleaddkamer;

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        kamerdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelRoomnewTask(id)
    }

    useEffect(() => {
        gethotel(id).then(result => {
            if (result.status === 200) {
                setHotel(result.hotel);
                refreshkamers()
                refreshkamertypes()
                refreshcleaningtasks()
                refreshcleaningtypes()
                refreshgeneralservicestasks()
            } else {
                setErrorMessage(t("error_retreive_hotel_data"))
            }
        });

        document.getElementById("viewcontractButton").style.display = "grid";
        document.getElementById("uploaddiv").style.display = "none";
        document.getElementById("editDiv").style.display = "grid";
        document.getElementById("saveDiv").style.display = "none";

    }, []);

    const refreshkamers = () => {
        //////console.log("in get objects")
        getRooms(hotel.Hotel_ID).then(res => {
            if (res.status === 200) {
                setKamers(res.items)
                kamerstab(0, res.items);
            } else {
                setErrorMessage("failed to retrieve rooms")
            }

        })
    }
    const refreshkamertypes = () => {
        setkamertypesarray([]);
        getRoomsTypes(hotel.Hotel_ID).then(res => {
            if (res.status === 200) {
                setKamerTypes(res.items)
            } else {
                setErrorMessage("Failed to retrieve room types")
            }

        })
    }

    const refreshcleaningtasks = () => {
        if (hotel.Hotel_ID) {
            getCleaningtasks().then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }
    const refreshgeneralservicestasks = () => {
        console.log()
        if (hotel.Hotel_ID) {
            getCleaningtasks(hotel.Hotel_ID, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setgeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const refreshcleaningtypes = () => {
        if (hotel.Hotel_ID) {
            getCleaningtypes(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTypes(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText, "failed to refresh cleaningtypes")
                }

            })
        }
    }

    useEffect(() => {
        if (hotel.Hotel_ID) {
            refreshkamers();
            refreshkamertypes();
            refreshcleaningtypes();
            refreshcleaningtasks();
            refreshgeneralservicestasks();
        }
    }, [hotel]);



    const kamerstab = (index, items = false) => {
        if (index === 0) {
            if (kamers[0]) {
                setTimeout(() => {
                    //////console.log("Delayed for 1 second.");
                    if (items !== false) {
                        //////console.log(items)
                        //Createkamerslist(items, "roomslist")

                    } else {
                        //Createkamerslist(kamers, "roomslist")
                    }

                }, "10");

            }

        }
        if (index === 1) {
            if (kamerTypes[0]) {
                setTimeout(() => {
                    if (items !== false) {
                        //////console.log(items)
                        //Createkamertypeslist(items, "typeslist")
                    } else {
                        // Createkamertypeslist(kamerTypes, "typeslist")
                    }
                }, "10");

            }

        }

    }
    const handleitemchange = (e) => {
        //console.log(e.target.name, ":", e.target.value)
        setHotel((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })
        //console.log(hotel)
        setToUpdate((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })

    }
    const handleEdit = () => {
        setIconDisabled(true);
        setTabsDisabled(true)
        setIsDisabled(false);
    }

    const handleCancel = () => {
        window.location.reload();
    }


    const handleSave = (e) => {
        e.preventDefault();

        setIconDisabled(false);
        setTabsDisabled(false)

        if (contract.value.name) {
            updateHotelData({ ...toUpdate, Contract: contract }, hotel.Hotel_ID).then(() => {
                window.location.reload();
            })
        } else {
            updateHotelData({ ...toUpdate }, hotel.Hotel_ID).then(() => {
                //////console.log('/hotels/' + hotel.Hotel_ID)
                window.location.reload();
            })

        }

    }

    const openContract = () => {
        window.open(getserverurl() + hotel.Contract, "_blank")
    }

    const handleaddfloor = () => {
        //console.log("floordescriptioninput")
        setIconDisabled(false);
        setTabsDisabled(false);
        //setIsDisabled(true);
        const floordescription = document.getElementById("floordescriptioninput").value
        const hotelid = hotel.Hotel_ID;
        createfloor(floordescription, hotelid).then((res) => {
            if (res.status === 200) {
                refreshkamers();
                document.getElementById("kamersarray").removeChild(document.getElementById("inputdiv"));
            } else {
                setErrorMessage(res.statusText)
            }

        })

    }


    const handleaddkamer = () => {

        setIconDisabled(false);
        setTabsDisabled(false);
        //setIsDisabled(true);
        const roomnumer = document.getElementById("kamernummerinput").value
        const kamertypid = document.getElementById("kamertypeid").value
        // const floor = document.getElementById("floorinput").value
        const hotelid = hotel.Hotel_ID;
        createroom(roomnumer, kamertypid, hotelid).then((res) => {
            if (res.status === 200) {

                refreshkamers();
                document.getElementById("kamersarray").removeChild(document.getElementById("inputdiv"));
            } else {
                setErrorMessage(res.statusText)
            }

        })

    }

    const handleaddkamerType = () => {
        const Kamertypename = document.getElementById("kamernummerinput").value
        const hotelid = hotel.Hotel_ID;

        setIconDisabled(false);
        setTabsDisabled(false);
        //setIsDisabled(true);
        createroomtype(Kamertypename, hotelid).then((res) => {
            if (res.status === 200) {
                res.json().then(body => {
                    setKamerTypes(pre => body)
                    document.getElementById("kamerstypeaaray").removeChild(document.getElementById("toberemoved"));
                })
            } else {
                setErrorMessage(res.statusText)
            }

        })
    }


    const handleaddCleaningTask = () => {
        setIconDisabled(false);
        setTabsDisabled(false);
        const taskDescription = document.getElementById("cleaningtaskdescription").value
        const hotel_Id = null;
        const taskDuration = 0;
        const promise = saveCleaningtask({ taskDescription, hotel_Id, taskDuration })

        promise.then((response) => {
            if (response.status === 200) {
                response.json().then((body) => {
                    //////console.log(body.items);
                    document.getElementById("cleaningtaskarray").removeChild(document.getElementById("toberemoved"))
                    setCleaningTasks(body.items)
                    setcleaningtaskarray([]);
                    refreshcleaningtasks();
                })
            }
            else {
                setErrorMessage(response.statusText);
            }
        })
    }

    const handleaddGeneralServicesTask = () => {
        setIconDisabled(false);
        setTabsDisabled(false);
        const taskDescription = document.getElementById("generalservicestaskdescription").value
        const hotel_Id = hotel.Hotel_ID;
        const taskDuration = checkdecimaldelimiter(document.getElementById("generalservicestaskproductivity").value);
        const multiple = document.getElementById("generalservicestaskmultiple").checked;
        const AD = document.getElementById("generalservicestaskAD").checked;

        const promise = saveCleaningtask({ taskDescription, hotel_Id, taskDuration, multiple, AD })

        promise.then((response) => {
            if (response.status === 200) {
                response.json().then((body) => {
                    document.getElementById("generalservicestaskarray").removeChild(document.getElementById("toberemoved"))
                    setgeneralservicestasks(body.items)
                    setgeneralservicestasksarray([]);
                    refreshgeneralservicestasks();
                })
            }
            else {
                setErrorMessage(response.statusText);
            }
        })
    }


    const handleaddCleaningType = () => {
        setIconDisabled(false);
        setTabsDisabled(false);
        const description = document.getElementById("cleaningtypedescription").value
        const hotel_Id = hotel.Hotel_ID;
        const duration = checkdecimaldelimiter(document.getElementById("cleaningtypeduration").value);
        const roomtype_id = document.getElementById("RoomType").value;
        const type = document.getElementById("cl_type").value;

        //////console.log("cleaningtypedescription = " + description)
        //////console.log("hotelid = " + hotel_Id)
        //////console.log("cleaningtypeduration = " + duration)


        const promise = saveCleaningtype({ description, hotel_Id, duration, roomtype_id, type })

        promise.then((response) => {
            if (response.status === 200) {
                response.json().then((body) => {

                    document.getElementById("cleaningtypearray").removeChild(document.getElementById("toberemoved"))
                    setCleaningTypes(body.items)
                    setcleaningtypearray([]);
                    refreshcleaningtypes();

                })
            }
            else {
                setErrorMessage(response.statusText);
            }
        })

    }

    const addKamertypefield = () => {
        setIconDisabled(true);
        setTabsDisabled(true);
        let list = document.getElementById("typeslist");
        const kamerdiv = document.createElement("div");
        const kamernummer = document.createElement("input");
        kamernummer.className = "RTlinkVarientInput";
        kamernummer.type = "text";
        kamernummer.id = "kamernummerinput";

        kamerdiv.appendChild(kamernummer);


        kamerdiv.className = hotelcss.RTlinkVarientInput
        const kamerTypeAray = document.getElementById("kamerstypeaaray")

        kamerTypeAray.insertBefore(kamerdiv, kamerTypeAray.firstChild);

        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";
        kamerdiv.appendChild(addbut);
        addbut.onclick = () => handleaddkamerType();
        kamerdiv.id = "toberemoved";
        kamernummer.focus();

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        kamerdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelRoomTypenewTask(id)


    }

    const addCleaningtaskfield = () => {
        setIconDisabled(true);
        setTabsDisabled(true);
        const cleaningdiv = document.createElement("div");
        //addname element to div
        const cleaningtaskdescription = document.createElement("input");
        cleaningtaskdescription.className = hotelcss.CTinput;
        cleaningtaskdescription.type = "text";
        cleaningtaskdescription.id = "cleaningtaskdescription";
        cleaningdiv.appendChild(cleaningtaskdescription);


        cleaningdiv.className = hotelcss.CTlinkVarientInput
        const cleaningtaskarray = document.getElementById("cleaningtaskarray")

        cleaningtaskarray.insertBefore(cleaningdiv, cleaningtaskarray.firstChild);


        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";

        cleaningdiv.appendChild(addbut);
        addbut.onclick = () => handleaddCleaningTask()
        cleaningdiv.id = "toberemoved"
        cleaningtaskdescription.focus()

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        cleaningdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelCleaningTasknewTask(id)

    }
    const seticondisabled = (boolvalue) => {
        setIconDisabled(boolvalue);
    }
    const settabsdisabled = (boolvalue) => {
        setTabsDisabled(boolvalue);
    }

    const addGeneralServicestaskfield = () => {
        setIconDisabled(true);
        setTabsDisabled(true);
        const generalservicesdiv = document.createElement("div");
        //addname element to div
        const generalservicestaskdescription = document.createElement("input");
        generalservicestaskdescription.className = hotelcss.CTinput;
        generalservicestaskdescription.type = "text";
        generalservicestaskdescription.id = "generalservicestaskdescription";
        generalservicesdiv.appendChild(generalservicestaskdescription);

        const generalservicestaskproductivity = document.createElement("input");
        generalservicestaskproductivity.className = hotelcss.CTinput;
        generalservicestaskproductivity.type = "decimal";
        generalservicestaskproductivity.id = "generalservicestaskproductivity";
        generalservicesdiv.appendChild(generalservicestaskproductivity);

        const generalservicestaskmultiple = document.createElement("input");
        generalservicestaskmultiple.className = hotelcss.CTinput;
        generalservicestaskmultiple.type = "checkbox";
        generalservicestaskmultiple.id = "generalservicestaskmultiple";
        generalservicesdiv.appendChild(generalservicestaskmultiple);

        const generalservicestaskAD = document.createElement("input");
        generalservicestaskAD.className = hotelcss.CTinput;
        generalservicestaskAD.type = "checkbox";
        generalservicestaskAD.id = "generalservicestaskAD";
        generalservicesdiv.appendChild(generalservicestaskAD);

        generalservicesdiv.className = hotelcss.GSlinkVarientInput

        const generalservicestaskarray = document.getElementById("generalservicestaskarray")
        generalservicestaskarray.insertBefore(generalservicesdiv, generalservicestaskarray.firstChild);

        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";

        generalservicesdiv.appendChild(addbut);
        addbut.onclick = () => handleaddGeneralServicesTask()
        generalservicesdiv.id = "toberemoved"
        generalservicestaskdescription.focus()

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        generalservicesdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelGeneralServicesTasknewTask(id)

    }


    const showAssignedCleaningTasks = async (id) => {
        let divheight_local = 0;
        if (document.getElementById("multiselectdiv").style.display === "none") {
            setcleaningtaskstoassignarray([]);
            const response = await getlinkedtasks(id);
            if (response.status === 200) {
                const body = await response.json()
                divheight_local = 25 * body.items.length;
                enterlinkedTasks(body.items)
                if (cleaningTasks !== null && cleaningTasks.length > 0) {
                    setcleaningtaskstoassignarray([]);
                    setLinkedtasks((prev) => {
                        if (!body.items) prev = {};
                        body.items.forEach((item, index) => {
                            setcleaningtaskstoassignarray(pre => [...pre,
                            <div id={item.Id} className={index % 2 === 0 ? hotelcss.AssignedTasksmultiselect1 : hotelcss.AssignedTasksmultiselect2} >
                                <p>{item.taskDescription} </p>
                            </div>
                            ])
                        })

                    })
                }
            }
            document.getElementById("multiselectdiv").style.top = (document.getElementById("showcleaningtasks" + id).getBoundingClientRect().top + divheight_local) + "px"
            document.getElementById("multiselectdiv").style.left = (document.getElementById("showcleaningtasks" + id).offsetLeft + 15) + "px"
            document.getElementById("multiselectdiv").style.display = "block";
            window.addEventListener("click", (e) => closeMultiselect(e, id))
        } else {
            document.getElementById("multiselectdiv").style.display = "none";
        }
    }

    const createcleaningtasksarray = async (id) => {
        let divheight_local = 0;
        document.getElementById("multiselectdiv").style.top = (document.getElementById("btn_AssignCleaningTasks" + id).offsetTop + 35) + "px"
        document.getElementById("multiselectdiv").style.left = (document.getElementById("btn_AssignCleaningTasks" + id).offsetLeft) + "px"
        if (document.getElementById("multiselectdiv").style.display === "none") {
            setcleaningtaskstoassignarray([]);
            const response = await getlinkedtasks(id)
            if (response.status === 200) {
                const body = await response.json()
                divheight_local = 25 * body.items.length;
                enterlinkedTasks(body.items)
                if (cleaningTasks.length > 0) {
                    setcleaningtaskstoassignarray([]);
                    setLinkedtasks((prev) => {
                        if (!prev) prev = {};
                        cleaningTasks.forEach((item, index) => {
                            setcleaningtaskstoassignarray(pre => [...pre,
                            <div id={item.Id} className={index % 2 === 0 ? hotelcss.CTypemultiselect1 : hotelcss.CTypemultiselect2} >
                                <input type="checkbox" className={hotelcss.CTypemultiselectcheckbox} id={item.Id} checked={prev[item.Id]} name={item.Id} onChange={(e) => changetaskcheckbox(e, id)} />
                                <p>{item.taskDescription}</p>
                            </div>
                            ])
                        })
                    })
                }
            }
            document.getElementById("multiselectdiv").style.top = (document.getElementById("btn_AssignCleaningTasks" + id).getBoundingClientRect().top + divheight_local) + "px"
            document.getElementById("multiselectdiv").style.left = (document.getElementById("btn_AssignCleaningTasks" + id).offsetLeft + 25) + "px"
            document.getElementById("multiselectdiv").style.display = "block";
            window.addEventListener("click", (e) => myfunction(e, id))
        } else {
            document.getElementById("multiselectdiv").style.display = "none";
        }
    }

    function enterlinkedTasks(tasks) {
        setLinkedtasks({})
        tasks.forEach(task => {
            setLinkedtasks((prev) => {
                return {
                    ...prev,
                    [task.Id]: true
                }
            })
        })
    }

    const handleassignCleaningTasks = (id, test) => {
        if (test === undefined) {
            setIconDisabled(true);
            setTabsDisabled(true);
            document.getElementById("multiselectdiv").style.top = (document.getElementById("btn_AssignCleaningTasks" + id).offsetTop + 35) + "px"
            document.getElementById("multiselectdiv").style.left = (document.getElementById("btn_AssignCleaningTasks" + id).offsetLeft) + "px"
        } else {

            document.getElementById("multiselectdiv").style.top = (document.getElementById("showcleaningtasks" + id).offsetTop + 35) + "px"
            document.getElementById("multiselectdiv").style.left = (document.getElementById("showcleaningtasks" + id).offsetLeft) + "px"
        }
        if (document.getElementById("multiselectdiv").style.display === "none") {
            createcleaningtasksarray(id);
        }
    }

    const changetaskcheckbox = (e, id) => {
        setLinkedtasks((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })

        setLinkedtasks((prev) => {
            savelinkedTasks(id, prev).then((res) => {
                if (res.status !== 200) {
                    setErrorMessage(res.statusText)
                } else {
                    setcleaningtaskstoassignarray(pre => []);
                    createcleaningtasksarray(id)
                }
            })
        })
    }

    const addCleaningtypefield = () => {
        setIconDisabled(true);
        setTabsDisabled(true);

        const cleaningdiv = document.createElement("div");
        const type = document.createElement("select");
        type.id = "cl_type";
        type.className = "typeselect"
        const optionblijver = document.createElement("option");
        optionblijver.value = "0"
        optionblijver.innerText = t("Blijver");
        optionblijver.selected = true
        type.appendChild(optionblijver);

        const optionvertrekker = document.createElement("option");
        optionvertrekker.value = "1"
        optionvertrekker.innerText = t("Vertrekker");
        type.appendChild(optionvertrekker);

        const flitskamer = document.createElement("option");
        flitskamer.value = "2"
        flitskamer.innerText = t('Flitskamer')
        type.appendChild(flitskamer);

        const Dagelijkseschoonmaak = document.createElement("option");
        Dagelijkseschoonmaak.value = "3"
        Dagelijkseschoonmaak.innerText = t('dailyclean');
        type.appendChild(Dagelijkseschoonmaak);

        const Wekelijkseschoonmaak = document.createElement("option");
        Wekelijkseschoonmaak.value = "4"
        Wekelijkseschoonmaak.innerText = t('weeklyClean');
        type.appendChild(Wekelijkseschoonmaak);

        const Eindschoonmaak = document.createElement("option");
        Eindschoonmaak.value = "5"
        Eindschoonmaak.innerText = t('finalClean');
        type.appendChild(Eindschoonmaak);

        cleaningdiv.appendChild(type);

        const cleaningtypedescription = document.createElement("input");
        cleaningtypedescription.className = hotelcss.CTinput;
        cleaningtypedescription.type = "text";
        cleaningtypedescription.id = "cleaningtypedescription";
        cleaningdiv.appendChild(cleaningtypedescription);


        const Type = document.createElement("select");
        Type.id = "RoomType"
        cleaningdiv.appendChild(Type);

        for (const type of kamerTypes) {
            const option = document.createElement("option")
            option.innerText = type.Naam;
            option.value = type.id;
            Type.appendChild(option)
        }

        const cleaningtypeduration = document.createElement("input");
        cleaningtypeduration.className = hotelcss.CTinput;
        cleaningtypeduration.type = "decimal";
        cleaningtypeduration.id = "cleaningtypeduration";
        cleaningdiv.appendChild(cleaningtypeduration);

        cleaningdiv.className = hotelcss.CTypelinkVarientInput
        const cleaningtypearray = document.getElementById("cleaningtypearray")

        cleaningtypearray.insertBefore(cleaningdiv, cleaningtypearray.firstChild);
        const Icontasks = document.getElementById("cleaningservices").cloneNode(true);

        const addCleaningTasks = document.createElement("Button");
        addCleaningTasks.appendChild(Icontasks)
        addCleaningTasks.id = "btn_AssignCleaningTasks" + id;
        addCleaningTasks.disabled = { tabsDisabled }
        addCleaningTasks.className = "AddButtonTable";

        cleaningdiv.appendChild(addCleaningTasks);

        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        const addbut = document.createElement("Button");
        addbut.appendChild(IconSave)
        addbut.className = "AddButtonTable";

        cleaningdiv.appendChild(addbut);
        addbut.onclick = () => handleaddCleaningType()
        cleaningdiv.id = "toberemoved"

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        cleaningdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelCleaningTypenewTask(id)
    }


    useEffect(() => {
        setcleaningtypearray([]);
        if (CleaningTypes.length > 0) {
            const types = CleaningTypes
            types.forEach((item, index) => {
                let typedesc = t('Blijver');
                if (item.type === 1) {
                    typedesc = t('Vertrekker');
                }
                if (item.type === 2) {
                    typedesc = t('Flitskamer');
                }
                if (item.type === 3) {
                    typedesc = t("dailyclean");
                }
                if (item.type === 4) {
                    typedesc = t("weeklyClean");
                }
                if (item.type === 5) {
                    typedesc = t("finalClean");
                }
                setcleaningtypearray(pre => [...pre,
                <div id={item.Id} className={index % 2 === 0 ? hotelcss.CTypelinkVarient1 : hotelcss.CTypelinkVarient2} >
                    <p className='kamertypenaam'>{typedesc}</p>
                    <p className='kamertypenaam'>{item.description}</p>
                    <p className='kamertypenaam'>{item.Naam}</p>
                    <p>{item.duration}</p>
                    <p id={"showcleaningtasks" + item.Id}><MdCleaningServices onClick={iconDisabled ? null : () => showAssignedCleaningTasks(item.Id)} /></p>
                    <div className='crudbuttons'>
                        <MdEdit onClick={iconDisabled ? null : () => handleCleaningTypeEditClick(item.Id, item, index)} />
                        <MdDelete onClick={iconDisabled ? null : () => handlecleaningTypeDeleteClick(item)} />
                    </div>
                </div>
                ])
            })
        }

    }, [CleaningTypes, iconDisabled]);

    useEffect(() => {
        if (cleaningTasks.length > 0) {
            const types = cleaningTasks
            const array = []
            setcleaningtaskarray([]);
            types.forEach((item, index) => {
                if (item.hotel_Id === null) {
                    setcleaningtaskarray(pre => [...pre,
                    <div id={item.Id} className={index % 2 === 0 ? hotelcss.CTlinkVarient1 : hotelcss.CTlinkVarient2} >
                        <p>{item.taskDescription}</p>
                        <div className='crudbuttons'>
                            <MdEdit onClick={iconDisabled ? null : () => handleCleaningTaskEditClick(item.Id, item, index)} />
                            <MdDelete onClick={iconDisabled ? null : () => handleCleaningTaskDeleteClick(item)} />
                        </div>
                    </div>
                    ])
                }
            })
        }

    }, [cleaningTasks, iconDisabled]);

    useEffect(() => {
        if (generalservicestasks.length > 0) {
            const types = generalservicestasks
            const array = []
            setgeneralservicestasksarray([]);
            types.forEach((item, index) => {
                if (item.hotel_Id === hotel.Hotel_ID) {
                    setgeneralservicestasksarray(pre => [...pre,
                    <div id={item.Id} className={index % 2 === 0 ? hotelcss.GSlinkVarient1 : hotelcss.GSlinkVarient2} >
                        <p>{item.taskDescription}</p>
                        <p>{item.taskDuration}</p>
                        <p>{item.multiple}</p>
                        <p>{item.AD}</p>
                        <div className='crudbuttons'>
                            <MdEdit onClick={iconDisabled ? null : () => handleGeneralServicesTaskEditClick(item.Id, item, index)} />
                            <MdDelete onClick={iconDisabled ? null : () => handleGeneralServicesTaskDeleteClick(item)} />
                        </div>
                    </div>
                    ])
                }
            })
        }

    }, [generalservicestasks, iconDisabled]);

    useEffect(() => {
        setkamertypesarray([]);
        if (kamerTypes.length > 0) {
            const types = kamerTypes
            types.forEach((item, index) => {
                setkamertypesarray(pre => [...pre,
                <div id={item.id} className={index % 2 === 0 ? hotelcss.RTlinkVarient1 : hotelcss.RTlinkVarient2} >
                    <p>{item.Naam}</p>
                    <div className='crudbuttons'>
                        <MdEdit onClick={iconDisabled ? null : () => handleKamerTypeEditClick(item.id, item, index)} />
                        <MdDelete onClick={iconDisabled ? null : () => handleKamerTypeDeleteClick(item.Naam, item.id)} />
                    </div>
                </div>
                ])
            })
        }
    }, [kamerTypes, iconDisabled]);

    useEffect(() => {
        setkamersarray([]);
        if (kamers.length > 0) {
            kamers.forEach((item, index) => {
                setkamersarray(pre => [...pre,
                <div id={item.kamerNummer} className={index % 2 === 0 ? hotelcss.RoomlinkVarient1 : hotelcss.RoomlinkVarient2} >
                    <p>{item.kamerNummer}</p>
                    <p>{item.Naam}</p>
                    <div className='crudbuttons'>
                        <MdEdit onClick={iconDisabled ? null : () => handleKamerEditClick(item.kamerNummer, item, index)} />
                        <MdDelete onClick={iconDisabled ? null : () => handleKamerDeleteClick(item.kamerNummer)} />
                    </div>
                </div>
                ])
            })
        }
    }, [kamers, iconDisabled]);

    const handleCleaningTaskEditClick = (id, item) => {
        setIconDisabled(true);
        setTabsDisabled(true);

        const cleaningtaskdiv = document.getElementById(id)
        cleaningtaskdiv.innerHTML = ""
        //addname element to div
        const type = document.createElement("input");
        type.id = "taskdescription" + id
        type.value = item.taskDescription
        type.className = hotelcss.CTinput;
        cleaningtaskdiv.appendChild(type);


        cleaningtaskdiv.className = hotelcss.CTlinkVarientInput

        const savebutton = document.createElement("Button");
        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        savebutton.appendChild(IconSave)
        savebutton.className = "AddButtonTable";
        cleaningtaskdiv.id = "toberemoved"
        cleaningtaskdiv.appendChild(savebutton);
        savebutton.onclick = () => handleEditCleaningTaskSave(id)

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        cleaningtaskdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelCleaningTaskSave(id)
    }

    const handleGeneralServicesTaskEditClick = (id, item) => {
        setIconDisabled(true);
        setTabsDisabled(true);
        const cleaningtaskdiv = document.getElementById(id)
        cleaningtaskdiv.innerHTML = ""
        //addname element to div
        const type = document.createElement("input");
        type.id = "generalservicestaskdescription" + id
        type.value = item.taskDescription
        type.className = hotelcss.CTinput;
        cleaningtaskdiv.appendChild(type);

        const productivity = document.createElement("input");
        productivity.id = "generalservicestaskproductivity" + id
        productivity.value = item.taskDuration
        productivity.className = hotelcss.CTinput;
        cleaningtaskdiv.appendChild(productivity);

        const muliple = document.createElement("input");
        muliple.id = "generalservicestaskmultiple" + id
        if (item.multiple === 1) {
            muliple.checked = true;
        }
        muliple.value = item.multiple
        muliple.type = "checkbox"
        muliple.className = hotelcss.CTinput;
        cleaningtaskdiv.appendChild(muliple);

        const AD = document.createElement("input");
        AD.id = "generalservicestaskAD" + id
        if (item.AD === 1) {
            AD.checked = true;
        }
        AD.value = item.AD
        AD.type = "checkbox"
        AD.className = hotelcss.CTinput;
        cleaningtaskdiv.appendChild(AD);

        cleaningtaskdiv.className = hotelcss.GSlinkVarientInput
        const savebutton = document.createElement("Button");
        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        savebutton.appendChild(IconSave)
        savebutton.className = "AddButtonTable";
        cleaningtaskdiv.id = "toberemoved"
        cleaningtaskdiv.appendChild(savebutton);
        savebutton.onclick = () => handleEditGeneralServicesTaskSave(id)

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        cleaningtaskdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelGeneralServicesTaskSave(id)
    }

    const handleCleaningTypeEditClick = (id, item) => {
        setIconDisabled(true);
        setTabsDisabled(true);
        getRoomsTypes(hotel.Hotel_ID).then(res => {
            const cleaningtaskdiv = document.getElementById(id);
            cleaningtaskdiv.innerHTML = "";
            const type = document.createElement("select");
            type.id = "type" + id;
            type.className = "typeselect"
            type.value = item.type;
            const optionblijver = document.createElement("option");
            optionblijver.value = "0"
            optionblijver.innerText = t("Blijver");
            if (item.type === 0) {
                optionblijver.selected = true
            }
            type.appendChild(optionblijver);
            const optionvertrekker = document.createElement("option");
            optionvertrekker.value = "1"
            optionvertrekker.innerText = t("Vertrekker");
            if (item.type === 1) {
                optionvertrekker.selected = true
            }
            type.appendChild(optionvertrekker);

            const flitskamer = document.createElement("option");
            flitskamer.value = "2"
            flitskamer.innerText = t("Flitskamer");
            if (item.type === 2) {
                flitskamer.selected = true
            }
            type.appendChild(flitskamer);

            const Dagelijkseschoonmaak = document.createElement("option");
            Dagelijkseschoonmaak.value = "3"

            if (item.type === 3) {
                Dagelijkseschoonmaak.selected = true
            }
            Dagelijkseschoonmaak.innerText = t("dailyclean");
            type.appendChild(Dagelijkseschoonmaak);

            const Wekelijkseschoonmaak = document.createElement("option");
            Wekelijkseschoonmaak.value = "4"
            if (item.type === 4) {
                Wekelijkseschoonmaak.selected = true
            }
            Wekelijkseschoonmaak.innerText = t("weeklyClean");
            type.appendChild(Wekelijkseschoonmaak);

            const Eindschoonmaak = document.createElement("option");
            Eindschoonmaak.value = "5"
            if (item.type === 5) {
                Eindschoonmaak.selected = true
            }
            Eindschoonmaak.innerText = t("finalClean");
            type.appendChild(Eindschoonmaak);

            cleaningtaskdiv.appendChild(type);


            const Description = document.createElement("input");
            Description.id = "description" + id;
            Description.value = item.description;
            Description.className = hotelcss.CTinput;
            cleaningtaskdiv.appendChild(Description);

            const Type = document.createElement("select");
            Type.id = "RoomType" + id

            cleaningtaskdiv.appendChild(Type);
            for (const type of kamerTypes) {
                const option = document.createElement("option");
                if (item.roomtype_id === type.id) {
                    option.selected = true
                }
                else {
                    option.selected = false
                }
                option.innerText = type.Naam;
                option.value = type.id;
                Type.appendChild(option);
            }

            const duration = document.createElement("input");
            duration.type = "decimal";
            duration.id = "duration" + id;
            duration.value = item.duration;
            duration.className = hotelcss.CTinput;
            cleaningtaskdiv.appendChild(duration);

            const cleaningserviceIcon = document.getElementById("cleaningservices").cloneNode(true);
            const IconSave = document.getElementById("IconSave").cloneNode(true);
            const IconCancel = document.getElementById("IconCancel").cloneNode(true);
            cleaningserviceIcon.style.display = "block";
            const addCleaningTasks = document.createElement("Button");
            addCleaningTasks.className = "AddButtonTable";
            addCleaningTasks.appendChild(cleaningserviceIcon)
            addCleaningTasks.id = "btn_AssignCleaningTasks" + item.Id;
            addCleaningTasks.className = "AddButtonTable";

            addCleaningTasks.onclick = () => handleassignCleaningTasks(item.Id)
            cleaningtaskdiv.appendChild(addCleaningTasks);
            cleaningtaskdiv.className = hotelcss.CTypelinkVarientInput;

            const savebutton = document.createElement("Button");
            savebutton.appendChild(IconSave);
            savebutton.className = "AddButtonTable";
            cleaningtaskdiv.id = "toberemoved";
            cleaningtaskdiv.appendChild(savebutton);
            savebutton.onclick = () => handleEditCleaningTypeSave(id, linkedtasks);

            const cancelbutton = document.createElement("Button");
            cancelbutton.appendChild(IconCancel);
            cancelbutton.className = "AddButtonTable";
            cancelbutton.id = "tocancel";
            cleaningtaskdiv.appendChild(cancelbutton);
            cancelbutton.onclick = () => handleCancelCleaningTypeSave(id);
        })

    }

    const handleCancelRoomTypeSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        setkamertypesarray([]);
        refreshkamertypes();
    }

    const handleCancelCleaningTypeSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("multiselectdiv").style.display = "none";
        setcleaningtypearray([]);
        refreshcleaningtypes();
    }

    const handleCancelCleaningTaskSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        setcleaningtaskarray([]);
        refreshcleaningtasks();
    }

    const handleCancelGeneralServicesTaskSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        setgeneralservicestasksarray([]);
        refreshgeneralservicestasks();
    }

    const handleCancelKamerSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        setkamersarray([]);
        refreshkamers();
    }

    const handleCancelCleaningTypenewTask = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("multiselectdiv").style.display = "none";
        document.getElementById("cleaningtypearray").removeChild(document.getElementById("toberemoved"));
    }

    const handleCancelCleaningTasknewTask = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("cleaningtaskarray").removeChild(document.getElementById("toberemoved"))
        setcleaningtaskarray([]);
        refreshcleaningtasks();
    }
    const handleCancelGeneralServicesTasknewTask = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("generalservicestaskarray").removeChild(document.getElementById("toberemoved"))
        setcleaningtaskarray([]);
        refreshcleaningtasks();
    }

    const handleCancelRoomTypenewTask = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("kamerstypeaaray").removeChild(document.getElementById("toberemoved"))
        setcleaningtaskarray([]);
        refreshcleaningtasks();
    }

    const handleCancelRoomnewTask = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false);
        document.getElementById("kamersarray").removeChild(document.getElementById("inputdiv"))
        setkamersarray([]);
        refreshkamers();
    }
    const checkdecimaldelimiter = (value) => {
        return value.replace(/\,/g, '.')
    }

    const handleEditCleaningTypeSave = (id, tasks) => {
        document.getElementById("multiselectdiv").style.display = "none";
        setIconDisabled(false);
        setTabsDisabled(false)
        const description = document.getElementById("description" + id).value;
        const roomtype_id = document.getElementById("RoomType" + id).value;
        const type = document.getElementById("type" + id).value;
        const duration = checkdecimaldelimiter(document.getElementById("duration" + id).value);
        const response = editCleaningType(id, description, duration, roomtype_id, type);
        response.then(res => {
            if (res.status === 200) {
                savetasks(id)
            } else {
                setErrorMessage(res.statusText)
            }
        })

    }

    function savetasks(id) {
        setLinkedtasks((prev) => {
            savelinkedTasks(id, prev).then((res) => {
                if (res.status === 200) {
                    setcleaningtypearray([])
                    refreshcleaningtypes();
                } else {
                    setErrorMessage(res.statusText)
                }
            })

        })

    }

    const handleEditCleaningTaskSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false)
        const taskDescription = document.getElementById("taskdescription" + id).value;
        const taskDuration = 0;
        const response = editCleaningTask(id, taskDescription, taskDuration);
        response.then(res => {
            if (res.status === 200) {
                setcleaningtaskarray([])
                refreshcleaningtasks();
            } else {
                setErrorMessage(res.statusText)
            }
        })

    }

    const handleEditGeneralServicesTaskSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false)
        const taskDescription = document.getElementById("generalservicestaskdescription" + id).value;
        const taskDuration = checkdecimaldelimiter(document.getElementById("generalservicestaskproductivity" + id).value);
        const multiple = document.getElementById("generalservicestaskmultiple" + id).checked;
        const AD = document.getElementById("generalservicestaskAD" + id).checked;
        const response = editGeneralServicestask(id, taskDescription, taskDuration, multiple, AD);
        response.then(res => {
            if (res.status === 200) {
                setgeneralservicestasksarray([])
                refreshgeneralservicestasks();

            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const handleKamerEditClick = async (id, item) => {
        setIconDisabled(true);
        setTabsDisabled(true);
        getRoomsTypes(hotel.Hotel_ID).then(res => {
            if (res.status === 200) {
                setKamerTypes(res.items)
                const kamerdiv = document.getElementById(id)
                kamerdiv.innerHTML = ""
                //addname element to div
                const kamernummer = document.createElement("p");
                kamernummer.id = "kamernummerinput"
                kamernummer.innerText = id
                kamerdiv.appendChild(kamernummer);

                const Type = document.createElement("select");
                Type.onchange = (e) => setaddkamer({ ...addkamer, Type: e.target.value })
                kamerdiv.appendChild(Type);
                Type.id = "kamertypeid";

                kamerdiv.className = hotelcss.RoomlinkVarientInput;

                for (const type of res.items) {
                    const option = document.createElement("option")
                    option.innerText = type.Naam;
                    option.value = type.id;
                    if (item.Type === type.id) {
                        option.selected = true;
                    }
                    else { option.selected = false; }
                    Type.appendChild(option)
                }

                const savebutton = document.createElement("Button");

                const IconSave = document.getElementById("IconSave").cloneNode(true);
                const IconCancel = document.getElementById("IconCancel").cloneNode(true);

                savebutton.appendChild(IconSave)
                savebutton.className = "AddButtonTable";
                kamerdiv.id = "inputdiv"

                kamerdiv.appendChild(savebutton);
                savebutton.onclick = () => handleEditkamerSave(id)
                const cancelbutton = document.createElement("Button");
                cancelbutton.appendChild(IconCancel)
                cancelbutton.className = "AddButtonTable";
                cancelbutton.id = "tocancel"
                kamerdiv.appendChild(cancelbutton);
                cancelbutton.onclick = () => handleCancelKamerSave(id)

            } else {
                setErrorMessage(t("error_retreiveRooms"))
            }
        })
    }

    const handleEditkamerSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false)
        const type = document.getElementById("kamertypeid").value
        const response = editkamer(id, type, hotel.Hotel_ID);
        response.then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setkamersarray(pre => [])
                    setKamers(body);
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const handleKamerDeleteClick = (id) => {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteRoom_1") + id + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteRoom(id, hotel.Hotel_ID)
                        response.then(res => {
                            res.json().then(res => {
                                ////console.log(res.items)
                                setKamers(res.items)
                            }
                            )
                        })
                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };
        confirmAlert(options)
    }

    const handleKamerTypeEditClick = async (id, item) => {
        setIconDisabled(true);
        setTabsDisabled(true);
        const kamerdiv = document.getElementById(id)
        kamerdiv.innerHTML = ""
        //addname element to div
        const type = document.createElement("input");
        type.id = "kamername" + id
        type.value = item.Naam
        kamerdiv.appendChild(type);


        kamerdiv.className = hotelcss.RTlinkVarientInput

        const savebutton = document.createElement("Button");

        const IconSave = document.getElementById("IconSave").cloneNode(true);
        const IconCancel = document.getElementById("IconCancel").cloneNode(true);

        savebutton.appendChild(IconSave)
        savebutton.className = "AddButtonTable";
        kamerdiv.id = "toberemoved"
        kamerdiv.appendChild(savebutton);
        savebutton.onclick = () => handleEditkamerTypeSave(id)

        const cancelbutton = document.createElement("Button");
        cancelbutton.appendChild(IconCancel)
        cancelbutton.className = "AddButtonTable";
        cancelbutton.id = "tocancel"
        kamerdiv.appendChild(cancelbutton);
        cancelbutton.onclick = () => handleCancelRoomTypeSave(id)
    }

    const handleEditkamerTypeSave = (id) => {
        setIconDisabled(false);
        setTabsDisabled(false)
        const name = document.getElementById("kamername" + id).value
        const response = editkamerType(id, name, hotel.Hotel_ID);
        response.then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setkamertypesarray(pre => [])
                    setKamerTypes(body);
                    refreshkamers()
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })

    }

    const changecheckbox = (e) => {
        setHotel((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })
        setToUpdate((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.checked
            }
        })
    }

    function closeMultiselect(e, id) {
        try {
            const container = document.getElementById('showcleaningtasks' + id);
            const container2 = document.getElementById("multiselectdiv")
            if (!container.contains(e.target) && !container2.contains(e.target)) {
                document.getElementById("multiselectdiv").style.display = "none"
            }
        } catch (e) {

        }
    }

    function myfunction(e, id) {
        try {
            const container = document.getElementById('btn_AssignCleaningTasks' + id);
            const container2 = document.getElementById("multiselectdiv")
            if (!container.contains(e.target) && !container2.contains(e.target)) {
                document.getElementById("multiselectdiv").style.display = "none"
            }
        } catch (e) {
        }
    }

    const handleKamerTypeDeleteClick = (naam, id) => {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteRoomtype_1") + naam + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        deleteRoomtype(id).then((res) => {
                            if (res.status === 200) {
                                res.json().then(body => {
                                    ////console.log(body)
                                    setKamerTypes(body)
                                })
                            } else {
                                setErrorMessage(res.statusText)
                            }
                        })

                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    const handlecleaningTypeDeleteClick = (item) => {
        //////console.log(item)
        const options = {
            title: t("Delete?"),
            message: t("message_deleteCleaningtype_1") + item.description + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteCleaningType(item.Id)
                        response.then(res => {
                            res.json().then(res => {
                                ////console.log(res.items)
                                setCleaningTypes(res.items)
                            }
                            )

                        })

                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    const handleCleaningTaskDeleteClick = (item) => {
        const options = {
            title: t("Delete?"),
            message: t("message_deleteCleaningtask_1") + item.description + t("message_deleteRoom_2"),
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteCleaningTask(item.Id)
                        response.then(res => {
                            res.json().then(res => {
                                setCleaningTasks(res.items)
                            }
                            )

                        })

                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    const handleGeneralServicesTaskDeleteClick = (item) => {
        const options = {
            title: t("Delete?"),
            message: t("message_deletegeneralService_1") + item.taskDescription + t("message_deleteRoom_2"),//,
            buttons: [
                {
                    label: t("Yes"),
                    onClick: () => {
                        const response = deleteGeneralServicestasks(item.Id)
                        response.then(res => {
                            res.json().then(res => {
                                setgeneralservicestasks(res.items)
                            }
                            )

                        })

                    }
                },
                {
                    label: t("No"),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    function formatDateToYYYYMMDD(date) {
        if (date !== null) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
            const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
            return `${year}-${month}-${day}`;
        }
        else {
            return null
        }
    }

    const changedate = (e, datefield) => {
        console.log(e)
        setHotel((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
        setToUpdate((prev) => {
            return {
                ...prev,
                [datefield]: formatDateToYYYYMMDD(e)
            }
        })
    }

    return (
        <>
            <div id="main" onMouseMove={handleMouseMove} onMouseDown={setMouseDown} onMouseUp={stopMouseMove} >
                <div className='mousecoordinates'>
                    Mouse coordinates: {coord.x} {coord.y}
                </div>
                <header>
                    <div id="errordiv" className='error'></div>
                </header>
                <div id="return" className="form">
                    <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={() => navigate("/hotels")} >{t('Naaroverzicht')}</Button>
                </div>
                <HotelNode
                    rights={props.rights}
                    t={t}
                    isDisabled={isDisabled}
                    data={{ hotel: hotel }}
                    cleaningtaskstoassignarray={cleaningtaskstoassignarray}
                    kamersarray={kamersarray}
                    kamertypesarray={kamertypesarray}
                    cleaningtypearray={cleaningtypearray}
                    cleaningtaskarray={cleaningtaskarray}
                    generalservicesarray={generalservicestasksarray}
                    events={{
                        seticondisabled: seticondisabled,
                        settabsdisabled: settabsdisabled,
                        changedate: changedate,
                        handleCancel: handleCancel,
                        changecheckbox: changecheckbox,
                        handleitemchange: handleitemchange,
                        setContract: setContract,
                        kamerstab: kamerstab,
                        onSubmit: handleSave,
                        handleEdit: handleEdit,
                        addKamerfield: addKamerfield,
                        addKamertypefield: addKamertypefield,
                        addCleaningtypefield: addCleaningtypefield,
                        addCleaningtaskfield: addCleaningtaskfield,
                        addGeneralServicestaskfield: addGeneralServicestaskfield,
                        handleMouseMove: handleMouseMove,
                        setMouseDown: setMouseDown,
                        stopMouseMove: stopMouseMove
                    }}
                    tabsDisabled={tabsDisabled}
                    MousePosition={coord}
                />
            </div>
        </>
    )
}

export { Createhotel, Viewhotels, HotelView }